import React from 'react';
import './css/quickbar.css';
import QuickbarDetail from './QuickbarDetail';

class QucikBar extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      show: false,
      hover: false,
      detail: false,
      type: '',
      work: false,
      study: false,
    };
  }

  turnoff = () => {
    if (this.state.hover || this.props.hover) {
      setTimeout(this.turnoff, 500);
    } else {
      this.setState({ show: false });
    }
  };

  turnon = () => {
    this.setState({ show: true });
  };

  waitToOff = () => {
    this.setState({ hover: false });
    setTimeout(this.turnoff, 500);
  };

  shower = () => {
    this.setState({ detail: true, type: '日用品' });
  };

  feed = () => {
    this.setState({ detail: true, type: '食品' });
  };

  medicine = () => {
    this.setState({ detail: true, type: '药品' });
  };

  study = () => {
    this.setState({ detail: true, study: true, work: false });
  };

  work = () => {
    this.setState({ detail: true, work: true, study: false });
  };

  Off = () => {
    this.setState({ detail: false });
  };

  workOff = () => {
    this.setState({ detail: false, work: false, study: false });
  };

  render() {
    return (
      <div>
        {this.state.show ? (
          <div
            className="quickbar"
            style={{
              transform: `translate(calc(100vw - 300px + ${this.props.x}px),calc(100vh - 300px + ${this.props.y}px))`,
              cursor: `pointer`,
            }}
            onMouseOver={() => this.setState({ hover: true })}
            onMouseOut={this.waitToOff}
          >
            <div
              className="weishi minfunc"
              title="喂食"
              onClick={this.feed}
            ></div>
            <div
              className="xizao minfunc"
              title="洗澡"
              onClick={this.shower}
            ></div>
            <div
              className="kanbing minfunc"
              title="看病"
              onClick={this.medicine}
            ></div>
            <div
              className="xuexi minfunc"
              title="学习"
              onClick={() =>
                this.setState({ detail: true, study: true, work: false })
              }
            ></div>
            <div
              className="dagong minfunc"
              title="打工"
              onClick={() =>
                this.setState({ detail: true, work: true, study: false })
              }
            ></div>
          </div>
        ) : null}
        {this.state.detail ? (
          <QuickbarDetail
            x={this.props.x}
            y={this.props.y}
            shut={this.Off}
            shutwork={this.workOff}
            type={this.state.type}
            feed={this.props.feed}
            medicine={this.props.medicine}
            shower={this.props.shower}
            work={this.state.work}
            study={this.state.study}
            work1={this.props.work}
            study1={this.props.study}
            normal={this.props.normal}
          />
        ) : null}
      </div>
    );
  }
}
export default QucikBar;
